import {Injectable} from '@angular/core';
import {Observable, throwError} from "rxjs";
import {map} from "rxjs/operators";

import {SNS_API_URL, SNS_NAVER_API_URL} from "../../defines/protocol";
import {ApiService} from "../api/api.service";
import {LayoutMgrService} from "../layout-mgr/layout-mgr.service";
import {isValidNaverKey} from "../../defines/naver-key.func";

export type SnsInfo = {
  naver?: boolean;
};


@Injectable({
  providedIn: 'root'
})
export class SnsService {

  constructor(
    private api: ApiService,
    private lm: LayoutMgrService,
  ) {
  }

  public GetSnsInfo(): Observable<SnsInfo> {
    const url = SNS_API_URL;

    return this.api.Get(url).pipe(
      map(data => {
        console.log('SnsService::GetSnsInfo()', url, data);

        const snsInfo: SnsInfo = {};
        snsInfo.naver = data?.naver === 'Y';

        return snsInfo;
      })
    );
  }

  public ConnectNaverId(naverKey: string): Observable<void> {
    if (!isValidNaverKey(naverKey)) {
      console.error('SnsService::ConnectNaverId() invalid naverKey', naverKey);
      return throwError(() => ({detail: 'invalid naverKey'}));
    }

    const url = SNS_NAVER_API_URL + encodeURIComponent(naverKey.trim()) + '/';

    return this.api.Post(url, {}).pipe(
      map(data => {})
    );
  }

  public DisconnectNaverId(): Observable<void> {
    return this.api.Delete(SNS_NAVER_API_URL).pipe(
      map(data => {})
    );
  }

}
